import React from 'react'
import PropTypes from 'prop-types'

const PageValue = ({ hitsPerPage }) => (
  <span style={{ color: '#6d6e71', fontSize: '14px' }} data-testid="page-value-testid">
    ver
    <span style={{ color: '#0071ce', fontWeight: 'bold' }}>{` ${hitsPerPage} productos `}</span>
    por página
  </span>
)

PageValue.propTypes = {
  hitsPerPage: PropTypes.number.isRequired,
}

export default PageValue
